import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiClient } from "@/lib/api-client"

const API_BASE = "/api/coaching-sessions/saved"

export const toggleSavedCoachingSession = async (
  coachingSessionId: string,
): Promise<{ saved: boolean; message: string }> => {
  const { data } = await apiClient.post<{
    success: boolean
    data: { saved: boolean; message: string }
    message: string
  }>(API_BASE, { coachingSessionId })
  return {
    saved: data.data.saved,
    message: data.data.message,
  }
}

export const getSavedCoachingSessions = async (params?: {
  page?: number
  limit?: number
  search?: string
}): Promise<{
  sessions: Array<Record<string, unknown>>
  total: number
  page: number
  totalPages: number
  hasMore: boolean
}> => {
  const queryParams = new URLSearchParams()
  if (params?.page) queryParams.append("page", params.page.toString())
  if (params?.limit) queryParams.append("limit", params.limit.toString())
  if (params?.search) queryParams.append("search", params.search)

  const queryString = queryParams.toString()
  const { data } = await apiClient.get<{
    success: boolean
    data: {
      sessions: Array<Record<string, unknown>>
      total: number
      page: number
      totalPages: number
      hasMore: boolean
    }
    message: string
  }>(`${API_BASE}${queryString ? `?${queryString}` : ""}`)
  return data.data
}

export function useToggleCoachingSave() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (coachingSessionId: string) => toggleSavedCoachingSession(coachingSessionId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["saved-coaching-sessions"] })
      queryClient.invalidateQueries({ queryKey: ["user-coaching-sessions"] })
      queryClient.invalidateQueries({
        queryKey: ["coaching-session", variables],
      })
    },
  })
}
